import React from "react";
import {isEmpty} from "@helpers/helpers";
import {getPropertyTypesByCityId} from "@models/property";
import ApartmentIcon from '@icons/apartment.svg';
import ApartmentHotelIcon from '@icons/apartment_hotel.svg';
import VillaIcon from '@icons/villa.svg';
import HouseIcon from '@icons/house.svg';
import LandIcon from '@icons/land.svg';
import CommercialIcon from '@icons/commercial.svg';
import SuiteIcon from '@icons/suite.svg';
import OfficeIcon from '@icons/office.svg';
import HotelIcon from '@icons/hotel.svg';
import SalonIcon from '@icons/salon.svg';
import WarehouseIcon from '@icons/warehouse.svg';
import WorkhouseIcon from '@icons/workhouse.svg';
import FactoryIcon from '@icons/factory.svg';
import GardenIcon from '@icons/garden.svg';
import ResidentialComplexIcon from '@icons/residential_complex.svg';
import {inArray} from "../helpers/arrays";

export const propetyTypesIcons = {
    apartment: <ApartmentIcon/>,
    apartment_hotel: <ApartmentHotelIcon/>,
    villa: <VillaIcon/>,
    house: <HouseIcon/>,
    land: <LandIcon/>,
    commercial: <CommercialIcon/>,
    suite: <SuiteIcon/>,
    office: <OfficeIcon/>,
    hotel: <HotelIcon/>,
    salon: <SalonIcon/>,
    warehouse: <WarehouseIcon/>,
    workhouse: <WorkhouseIcon/>,
    factory: <FactoryIcon/>,
    garden: <GardenIcon/>,
    residential_complex: <ResidentialComplexIcon/>,
};

export const getTypesOptions = async (city_id, deal_type = null) => {
    let items = [];

    const getByDealType = !isEmpty(deal_type) ? getTypesByDealType(deal_type) : [];

    await getPropertyTypesByCityId(city_id).then(result => {

        for (let type of result.types) {
            let convertName = type.name.split('.')[0];

            if (!getByDealType.length || inArray(convertName, getByDealType)) {
                items.push({
                    value: type.name,
                    label: !isEmpty(type.caption) ? type.caption : type.title,
                    checked: false,
                    isSsr: (!process.browser),
                    iconsType: 'property_types',
                    icon: (process.browser) ? propetyTypesIcons[convertName] : convertName,
                })
            }
        }
    });

    return {
        options: items,
        selected_items: [],
    };
};

export const getTypeByKey = (types, type = null) => {
    let result = [];

    if (!isEmpty(type) && !isEmpty(types) && types.length) {

        if (typeof type === 'string') {
            types.filter(item => {
                if (item.value === type) {
                    result.push(item.label);
                }
            });
        } else if (typeof type === "object" && type.length) {
            types.filter(item => {
                type.filter(value => {
                    if (item.name === value) {
                        result.push(!isEmpty(item.caption) ? item.caption : item.title);
                    }
                })
            });
        }
    }

    return result;
};

export function getTypesByDealType(deal_type) {
    return typeListsByDealTypes[deal_type];
}

const typeListsByDealTypes = {
    'sale': [
        'apartment',
        'house',
        'villa',
        'commercial',
        'office',
        'land',
        'workhouse',
        'salon',
        'apartment_hotel',
        'suite',
        'garden',
        'residential_complex',
        'hotel',
        'warehouse',
        'factory',
        'old_house',
        'realestate',
    ],
    'rent': [
        'apartment',
        'house',
        'commercial',
        'office',
        'suite',
    ],
    'mortgage': [
        'apartment',
        'house',
        'commercial',
        'office',
        'suite',
    ],
    'pre_sale': [
        'apartment',
        'villa',
        'commercial',
        'office',
        'suite',
        'residential_complex',
        'realestate',
    ],
    'exchange': [
        'apartment',
        'house',
        'villa',
        'commercial',
        'office',
        'land',
        'workhouse',
        'salon',
        'apartment_hotel',
        'suite',
        'garden',
        'residential_complex',
        'hotel',
        'warehouse',
        'factory',
        'realestate',
    ],
    'participation': [
        'apartment',
        'house',
        'villa',
        'commercial',
        'office',
        'land',
        'residential_complex',
        'realestate',
    ],
};